import React from "react";
import { Flex, Icon, Text } from "@jsq/ds/core";

const NoAccessState = ({ height = 800 }: { height?: number | string }) => {
  return (
    <Flex
      data-testid="no-access-state-container"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
      style={{ height }}
    >
      <Icon type="objects-column" size="xxx-large" variant="outline" />
      <Text variant="h2" align="center">
        You don&apos;t have access to this dashboard
      </Text>
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Text variant="secondary-md" align="center">
          This dashboard does not exist or you do not have access to it.
        </Text>
        <Text variant="secondary-md" align="center">
          Contact your administrator to update your data access permissions.
        </Text>
      </Flex>
    </Flex>
  );
};

export default NoAccessState;
